import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Stack from '@mui/material/Stack';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import MovieIcon from '@mui/icons-material/Movie';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

function LikeOrWatchGuest() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <span>
      <span className="card-description"></span>
      <Stack direction="row" spacing={2}>
        <Button size="small" variant="contained" onClick={handleClickOpen} startIcon={<FavoriteBorderIcon/>}>Like</Button>
        <Button size="small" variant="contained" onClick={handleClickOpen} startIcon={<MovieIcon />}>Watch</Button>
        <Dialog onClose={handleClose} open={open}>
          <DialogTitle>Want to perform this operation?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Sign in to continue.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Stack direction="row" spacing={2}>
              <Button autoFocus variant="outlined" onClick={ handleClose }>
                Cancel
              </Button>
              <Button href="/signin" variant="outlined">Sign in</Button>
            </Stack>
          </DialogActions>
        </Dialog>
      </Stack>
    </span>
  );
}

function LikeOrWatchPremium({id, stock_in_favorites, new_watchlists } :any) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [liked, setLiked] = useState(stock_in_favorites);

  const [watchlists, setWatchlists] = useState(new_watchlists);

  const [firstWatchlistOpen, setFirstWatchlistOpen] = React.useState(false);
  const [existingWatchlistsOpen, setExistingWatchlistsOpen] = React.useState(false);

  const [selectedWatchlist, setSelectedWatchlist] = React.useState(null);
  const [watchlistName, setWatchlistName] = React.useState(null);

  const radioGroupRef = React.useRef(null);

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleClickFirstWatchlistOpen = () => {
    setFirstWatchlistOpen(true);
  };

  const handleFirstWatchlistClose = () => {
    setFirstWatchlistOpen(false);
  };

  const handleClickExistingWatchlistsOpen = () => {
    setExistingWatchlistsOpen(true);
  };

  const handleExistingWatchlistsClose = () => {
    setExistingWatchlistsOpen(false);
  };

  const handleWatchlistSelectionChange = (e) => {
    setSelectedWatchlist(e.target.value);
  }

  function handleAddToWatchlistClick() {
    addWatchlistItemRemote();
    handleExistingWatchlistsClose();
  }

  function completeLoading(data) {
    console.log(data)
    setWatchlists(data);
  }

/*
  function fetchWatchlists() {
    return [
      {
        id: 'xyz',
        name: 'super list'
      },
      {
        id: '233',
        name: 'Rule one list'
      }
    ];
  }
*/
  function fetchWatchlists() {
    const url = "/watchlists";

    fetch(url)
      .then(function(response) {
        if(!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then(response => response.json())
      .then(result => completeLoading(result))
      .catch(function(e) {
        console.log(e)
        //setPreviewMsg('Something went wrong loading the Screener Perview. Please try again');
      })
  }

  function addWatchlistItemRemote() {
    const url = '/watchlists/' + selectedWatchlist + '/watchlist_items?ticker=' + id;
    fetch(url, { method: 'POST' })
      .then(resp => resp.json)
  }

  function createWatchlistRemote() {
    if (watchlistName === null) {
      return null;
    }

    const url = '/watchlists' + '?name=' + watchlistName;
    const msg = fetch(url, { method: 'POST' })
      .then(resp => resp.json)

    fetchWatchlists();
    handleFirstWatchlistClose();
  }

  function remoteOperation(id, method) {
    const url = '/favorite_item/' + id;
    const msg = fetch(url, {method: method})
      .then(resp => resp.json)
  }

  function handleLiked() {
    if (liked === true) {
      setLiked(false);
      remoteOperation(id, 'DELETE')

    } else {
      setLiked(true);
      remoteOperation(id, 'POST')
    }
  }

  function handleWatchlistNameChange(event) {
    setWatchlistName(event.target.value);
  }

  return (
    <span>
      <span className="card-description"></span>
      <Stack direction="row" spacing={2}>
        <Button size="small" variant="contained" onClick={() => handleLiked() }  color={ liked === true ? 'secondary' : 'default'} startIcon={<FavoriteBorderIcon/>}>Like</Button>
        <Button size="small" variant="contained" onClick={ watchlists.length > 0 ? handleClickExistingWatchlistsOpen : handleClickFirstWatchlistOpen } startIcon={<MovieIcon />}>Watch</Button>
        <Dialog fullScreen={fullScreen} onClose={handleFirstWatchlistClose} open={firstWatchlistOpen}>
          <DialogTitle>Create your first watchlist</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {'Please re-add ' + id + ' to your watchlist after creating it'}
            </DialogContentText>
            <TextField
              required
              autoFocus
              margin="dense"
              id="watchlistName"
              label="Fill in a name for your Watchlist"
              fullWidth
              variant="standard"
              value={watchlistName}
              onChange={handleWatchlistNameChange}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleFirstWatchlistClose}>Cancel</Button>
            <Button onClick={createWatchlistRemote}>Submit</Button>
          </DialogActions>
        </Dialog>
        <Dialog fullScreen={fullScreen} onClose={handleExistingWatchlistsClose} open={existingWatchlistsOpen}>
          <DialogTitle>{'Add ' + id + ' to Watchlist'}</DialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              {'Select watchlist'}
            </DialogContentText>
            <RadioGroup
              ref={radioGroupRef}
              aria-label="watchlist"
              name="watchlist"
              value={selectedWatchlist}
              onChange={handleWatchlistSelectionChange}
            >
              {watchlists.map((item) => (
                <FormControlLabel
                  value={item.id}
                  key={item.id}
                  control={<Radio />}
                  label={item.name}
                />
              ))}
            </RadioGroup>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleExistingWatchlistsClose}>
              Cancel
            </Button>
            <Button onClick={handleAddToWatchlistClick}>Submit</Button>
          </DialogActions>
        </Dialog>
      </Stack>
    </span>
  );
}

function LikeOrWatchFreePlan() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <span>
      <span className="card-description"></span>
      <Stack direction="row" spacing={2}>
        <Button size="small" variant="contained" onClick={handleClickOpen} startIcon={<FavoriteBorderIcon/>}>Like</Button>
        <Button size="small" variant="contained" onClick={handleClickOpen} startIcon={<MovieIcon />}>Watch</Button>
        <Dialog onClose={handleClose} open={open}>
          <DialogTitle>Want to perform this operation?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Upgrade to premium to continue.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Stack direction="row" spacing={2}>
              <Button autoFocus variant="outlined" onClick={handleClose}>
                Cancel
              </Button>
              <Button href="/pricing" variant="outlined">Upgrade</Button>
            </Stack>
          </DialogActions>
        </Dialog>
      </Stack>
    </span>
  );
}

export {
  LikeOrWatchGuest,
  LikeOrWatchPremium,
  LikeOrWatchFreePlan
}
